import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import notificationsReducer from "./reducer/notifications/notificationsReducer"
import productManagementReducer from "./reducer/product_management/productManagementReducer"
import inventoryReducer from "./reducer/inventory/inventoryReducer"
import salesReducer from "./reducer/sales/salesReducer"

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...notificationsReducer,
    ...productManagementReducer,
    ...inventoryReducer,
    ...salesReducer,
});

const thecrunchloop_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default thecrunchloop_store;